module.exports = __webpack_public_path__ + "img/icon_4swap_mtg.e4e3dbd1.png";